module.exports = __webpack_public_path__ + "files/b4ba54e187f5b35225720edd98e16e33.png";